/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-array-index-key */
/* eslint-disable camelcase */
import { uniqueId, cloneDeep } from 'lodash';
import React from 'react';
import { Col, Row } from 'reactstrap';
import { Field } from 'redux-form';
import { addValidator, required } from 'redux-form-validators';
// import ImgFieldInput from '../../../../../../../../components/Fields/ImgFieldInput';
import TextInput from '../../../../../../../../helpers/Fields/InputField';
// import { uploadImg } from '../../../../../../actions';
import FieldAnswerItem from '../FieldAnswerItem/FieldAnswerItem';
import './style.module.scss';
import { MdQuestionAnswer } from 'react-icons/md';
import { RiDeleteBin2Fill } from 'react-icons/ri';

const uploadImg = () => {

}

const answerValidator = addValidator({
  validator: function (options, value, allValues) {
    if (value.text || value.url) {
      return true;
    }
    return {
      // id: 'form.errors.private_url',
      defaultMessage: options.msg || 'Заполните обязательно',
      // msg: options.msg,
    };
  },
});

function AnswerType4({ answers = [], rootChange, formatMessage }) {
  return (
    <Row className={'AnswerType4'}>
      {answers.map((_i, index) => (
        <Col md="12" key={'group_' + _i._id} className={'groupRow'}>
          {index > 0 && (
            <div
              className={'icon'}
              onClick={() => {
                rootChange(
                  'answers',
                  answers.filter((i, tmpI) => index != tmpI)
                );
              }}
            >
              <RiDeleteBin2Fill size={20} />
            </div>
          )}
          <br />
          {/* <Field
            name={`answers[${index}].url`}
            // label={I18n.t('Название группы вариантов')}
            component={ImgFieldInput}
            onUpload={uploadImg}
            // validate={[required()]}
          /> */}
          <Field
            name={`answers[${index}].title`}
            label={formatMessage('nameCategories')}
            component={TextInput}
            validate={[required()]}
          />
          <div className='items'>
            {_i.variants.map((_v, index_v) => (
              <Field
                key={'answer-' + index}
                name={`answers[${index}].variants[${index_v}]`}
                placeholder={formatMessage('changeText')}
                component={FieldAnswerItem}
                onDelete={index_v > 0 ? () => {

                  const tmp = answers.map(a => {
                    return {
                      ...a,
                      variants: a.variants.filter((v, i) => i != index_v)
                    }
                  })
                  rootChange('answers', [
                    ...tmp,
                  ]);
                } : null}
              />
            ))}
              <div
                className={'itemCreate'}
                onClick={() => {
                  const tmp = cloneDeep(answers);
                  tmp[index].variants = [
                    ...tmp[index].variants,
                    {
                      _id: uniqueId('variant-') + Date.now(),
                      text: '',
                      url: '',
                      order: tmp[index].variants.length + 1,
                      isTrue: false,
                    },
                  ];

                  rootChange('answers', [...tmp]);
                }}
              >
                {/* <MdQuestionAnswer size="100" /> */}
                <div className={'text'}>{formatMessage('addAnswerItem')}</div>
              </div>
          </div>
        </Col>
      ))}
      <Col md='12'>
        <div
          className={'btnNewGroup'}
          onClick={() => {
            rootChange('answers', [
              ...answers,
              {
                _id: uniqueId('answer-') + Date.now(),
                title: '',
                url: '',
                variants: [
                  {
                    _id: uniqueId('variant-') + Date.now(),
                    text: '',
                    url: '',
                    order: 1,
                    isTrue: false,
                  },
                ],
              },
            ]);
          }}
        >
          {formatMessage('addAnswersCategories')}
        </div>
      </Col>
    </Row>
  );
}

export default AnswerType4;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/components/components/Answers/components/AnswerType4/AnswerType4.jsx